export const PHONE_DISPLAY = "+91 87288 46666";
export const PHONE_TEL = "tel:+918728846666";
export const WHATSAPP_URL =
  "https://wa.me/918728846666?text=Hello%20Dr.%20Siddarth%20Singh%2C%20I%20would%20like%20to%20book%20a%20consultation%20for%20pulmonology%20care.";
export const EMAIL = "drsiddarthsingh@gmail.com";
export const EMAIL_MAILTO = "mailto:drsiddarthsingh@gmail.com";

export const PORTRAIT_URL = "/assets/dr-portrait.png";
export const AIIMS_LOGO = "/assets/aiims-logo.png";
export const IRCC_LOGO = "/assets/ircc-logo.png";

export const MARQUEE_KEYWORDS = [
  "Interventional Pulmonology",
  "EBUS Bronchoscopy",
  "Thoracoscopy",
  "ICU Critical Care",
  "Sleep Medicine",
  "Polysomnography",
  "COPD & Asthma Care",
  "ECMO Specialist",
  "AIIMS Bhubaneswar",
  "Zirakpur",
  "Panchkula",
  "Chandigarh Tricity",
];

export const CHAPTERS = [
  {
    num: "01",
    tag: "The Training",
    title: "AIIMS Bhubaneswar",
    subtitle: "DM — Pulmonary, Critical Care & Sleep Medicine",
    logo: "/assets/aiims-logo.png",
    logoAlt: "All India Institute of Medical Sciences Bhubaneswar emblem",
    body: "Super-speciality doctoral training at one of India's most prestigious Institutes of National Importance — mastering advanced bronchoscopy, EBUS, medical thoracoscopy, ECMO-level critical care and full-spectrum sleep medicine.",
  },
  {
    num: "02",
    tag: "The Crucible",
    title: "AIIMS Jodhpur · AIIMS Bathinda · GMCH Chandigarh",
    subtitle: "Clinical roles across three premier institutions",
    body: "Years of high-acuity practice across North India's most demanding tertiary centres — thousands of ICU admissions, complex airway interventions and interstitial lung disease clinics, refining a calm, protocol-driven approach to the sickest patients.",
  },
  {
    num: "03",
    tag: "The Leadership",
    title: "Amcare Hospital, Zirakpur & IRCC Hospital, Panchkula",
    subtitle: "Consultant, Pulmonary Critical Care & Sleep Medicine · Director, Institute of Respiratory & Critical Care",
    logo: "/assets/ircc-logo.png",
    logoAlt: "IRCC Group of Hospitals logo",
    body: "Today, Dr. Siddarth Singh leads advanced respiratory care in the Chandigarh tricity — bringing AIIMS-grade interventional pulmonology, critical care and sleep diagnostics to Zirakpur and Panchkula.",
  },
];

export const SERVICES = [
  {
    icon: "ScanLine",
    title: "EBUS — Endobronchial Ultrasound",
    body: "Minimally invasive staging of lung cancer and mediastinal lymph node biopsy — no surgical cuts, day-care precision diagnosis.",
    keywords: "EBUS bronchoscopy specialist Zirakpur Panchkula",
  },
  {
    icon: "Waypoints",
    title: "Bronchoscopy & Airway Interventions",
    body: "Flexible and rigid bronchoscopy, foreign body removal, airway stenting, tumour debulking and hemoptysis control.",
    keywords: "therapeutic bronchoscopy airway stenting Punjab",
  },
  {
    icon: "Layers",
    title: "Medical Thoracoscopy / Pleuroscopy",
    body: "Definitive diagnosis of pleural effusion, pleural biopsy and talc pleurodesis under local anaesthesia.",
    keywords: "thoracoscopy pleural effusion specialist Haryana",
  },
  {
    icon: "HeartPulse",
    title: "Advanced ICU & Critical Care",
    body: "Mechanical ventilation, ARDS protocols, sepsis management and ECMO-level care for the most critically ill.",
    keywords: "ICU critical care pulmonologist ventilator ECMO",
  },
  {
    icon: "MoonStar",
    title: "Sleep Medicine & Polysomnography",
    body: "Level-1 sleep studies, CPAP/BiPAP titration and complete care for obstructive sleep apnea and snoring.",
    keywords: "sleep apnea CPAP specialist Chandigarh",
  },
  {
    icon: "Wind",
    title: "Pulmonary Rehabilitation & Chronic Care",
    body: "Structured lung recovery programs for COPD, severe asthma, ILD and post-COVID breathlessness.",
    keywords: "COPD asthma ILD pulmonary rehabilitation tricity",
  },
];

export const CONDITION_TABS = [
  "Airway Diseases",
  "Critical & ICU",
  "Interventional & Oncology",
  "Sleep & Infections",
];

export const CONDITIONS = {
  "Airway Diseases": [
    { name: "COPD & Emphysema", note: "Breathlessness, chronic cough, smoking-related lung damage — spirometry-led staging and inhaler optimisation." },
    { name: "Severe Asthma", note: "Frequent attacks despite inhalers — phenotyping, biologic eligibility and step-up therapy." },
    { name: "Bronchiectasis", note: "Recurrent infections and mucus — airway clearance protocols and infection control." },
  ],
  "Critical & ICU": [
    { name: "ARDS & Respiratory Failure", note: "Ventilator and ECMO-protocol care for lungs that need maximal support." },
    { name: "Sepsis & Multi-organ Failure", note: "Protocol-driven ICU care with round-the-clock monitoring." },
    { name: "Post-COVID Lung Disease", note: "Breathlessness after COVID — structured rehabilitation back to full capacity." },
  ],
  "Interventional & Oncology": [
    { name: "Lung Cancer & Nodules", note: "Early detection, EBUS staging and biopsy — the fastest path from shadow to certainty." },
    { name: "Pleural Effusion", note: "Fluid around the lungs — thoracoscopy diagnosis and definitive drainage." },
    { name: "Pneumothorax", note: "Collapsed lung — emergency decompression and recurrence prevention." },
    { name: "Hemoptysis", note: "Coughing blood — urgent bronchoscopic localisation and control." },
  ],
  "Sleep & Infections": [
    { name: "Obstructive Sleep Apnea", note: "Loud snoring, daytime fatigue — polysomnography and CPAP titration that transforms sleep." },
    { name: "Tuberculosis (TB)", note: "Drug-sensitive and complex TB — bronchoscopic sampling and complete therapy." },
    { name: "Interstitial Lung Disease (ILD)", note: "Lung scarring — HRCT-led diagnosis, antifibrotic therapy and oxygen planning." },
    { name: "Pneumonia", note: "Severe or recurrent chest infections — ICU-grade care when it matters most." },
  ],
};

export const MEMBERSHIPS = [
  { abbr: "IABP", full: "Indian Association for Bronchology" },
  { abbr: "WABIP", full: "World Association for Bronchology & Interventional Pulmonology" },
  { abbr: "ECMO Society", full: "ECMO Society of India" },
  { abbr: "AIIMS Alumni", full: "AIIMS Medical Alumni Network" },
];

export const TESTIMONIALS = [
  {
    quote: "My father was on a ventilator for 11 days. Dr. Singh explained every step, every day. He walked out of the ICU breathing on his own.",
    name: "R. Sharma",
    meta: "Attendant, ICU Care — Panchkula",
    tag: "ICU Care",
  },
  {
    quote: "Three hospitals couldn't tell us what the shadow on my scan meant. One EBUS by Dr. Singh and we had a diagnosis the same afternoon.",
    name: "G. Kaur",
    meta: "EBUS Patient — Zirakpur",
    tag: "Bronchoscopy",
  },
  {
    quote: "I snored for 20 years and thought it was normal. After my sleep study and CPAP, I wake up before my alarm. I didn't know sleep could feel like this.",
    name: "H. Singh",
    meta: "Sleep Apnea Patient — Chandigarh",
    tag: "Sleep Apnea",
  },
  {
    quote: "My asthma controlled my life for a decade. Dr. Singh's step-wise plan gave me my morning walks back within two months.",
    name: "M. Verma",
    meta: "Severe Asthma — Mohali",
    tag: "Asthma",
  },
];

export const LOCATIONS = [
  {
    name: "Amcare Hospital",
    role: "Consultant — Pulmonary, Critical Care & Sleep Medicine",
    city: "Zirakpur, Punjab",
    detail: "VIP Road, Zirakpur — OPD consultations, bronchoscopy suite & sleep lab",
    timings: "OPD · 9:00 AM – 4:00 PM",
    maps: "https://www.google.com/maps/search/Amcare+Hospital+Zirakpur",
  },
  {
    name: "IRCC Hospital",
    role: "Director — Institute of Respiratory & Critical Care",
    city: "Panchkula, Haryana",
    detail: "Advanced ICU, interventional pulmonology & respiratory critical care",
    timings: "OPD · 4:00 PM – 9:00 PM",
    maps: "https://maps.app.goo.gl/ybEmXVu93TrYWTxXA",
  },
];

export const SEO_LINKS = [
  ["Pulmonologist in Chandigarh", "/pulmonologist-chandigarh"],
  ["Pulmonologist in Panchkula", "/pulmonologist-panchkula"],
  ["EBUS in Chandigarh", "/ebus-chandigarh"],
  ["Bronchoscopy in Chandigarh", "/bronchoscopy-chandigarh"],
  ["Interventional Pulmonology", "/interventional-pulmonology"],
  ["Sleep Specialist in Chandigarh", "/sleep-specialist-chandigarh"],
  ["Critical Care Specialist", "/critical-care-specialist"],
];
